<div class="SDeskSidePanel Open p-10" [ngClass]="size">
<ng-content></ng-content>
</div>
